export default "__VITE_ASSET__ndAk4EOZ__"